import { Alert, Snackbar } from '@mui/material';
import * as Sentry from '@sentry/react';
import SentryWrap from 'components/Sentry';
import { Col, Modal, Row } from "antd";
import { DeleteModal } from "components/Dialog";
import { ProfileAvatarPicker } from "components/ProfileImagePicker";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import DemoPreview from "components/ViewDemoModal";
import { useFirebase } from "containers/FirebaseContext";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  runTransaction,
  setDoc,
  updateDoc,
  where
} from 'firebase/firestore';
import { debounce, get, map } from "lodash";
import moment from 'moment';
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useDebateModal } from "store/OneWayDebate/selectors";
import { useCurrentClass } from "store/classes/selectors";
import { handleCreateOneWayDebate, handleSyncDebate, handleUpdateOneWayDebate } from "store/debate/thunks";
import { useClassGameActivity } from "store/one_game/selectors";
import { handleListClassSubmissions } from "store/submissions/thunks";
import { useCurrentUser, useUserProfileConfig } from "store/users/selectors";
import styled from "styled-components";
import "swiper/css";
import "swiper/css/bundle";
import {
  DebateNewLogo,
  debatePoster,
  newDebates
} from "utils/assets/images";
import { debate_icon } from "utils/assets/images/icons";
import { v4 } from 'uuid';
import DebateCommentSection from "./DebateCommentSection";
import DebateContentType from "./DebateContentType";
import DebateLiveSection from "./DebateLiveSection";
import DebateStudentDetail from "./DebateStudentDetail";
import DebateStudentType from "./DebateStudentType";
import StudentContent from "./StudentDebate/StudentContent";


const DebateModalWrapper = styled.div`
  max-height: 58px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  background: transparent;
  z-index: 11;
  -webkit-transition: all 1s ease 0s;
  transition: all 1s ease 0s;
  cursor: pointer;
  margin-bottom: 5px;
`;

const LoaderWrapper = styled.div`
  // position:absolute;
  z-index: 100;
`;

const DebateModal = ({debatesModal,setDebatesModal}) => {
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const [debateModal, invokeDebateModal, revokeDebateModal] = useDebateModal();
  const [editClick, setEditClick] = useState(true);
  const [contentType, setContentType] = useState(false);
  const [previousDebateId, setPreviousDebateId] = useState(null);
  const [allEditClick, setAllEditClick] = useState(true);
  const [allContentType, setAllContentType] = useState(false);
  const [openTeacherModal, setOpenTeacherModal] = useState("");
  const [openStudentModal, setOpenStudentModal] = useState("");

  const [studentEditClick, setStudentEditClick] = useState(true);
  const [studentContentType, setStudentContentType] = useState(false);
  const [indexs, setIndex] = useState(0);

  const [studentEditBlog, setStudentEditBlog] = useState(true);
  const [blogContentType, setBlogContentType] = useState(false);

  const [studentCommentSec, setStudentCommentSec] = useState(true);
  const [commentContentType, setCommentContentType] = useState(false);
  const [closeStudentModal, setCloseStudentModal] = useState(false);

  const [shareLoader, setShareLoader] = useState(false);

  const [debateResponse, setDebateResponse] = useState({});
  const [timer, setTimer] = useState(0);

  const [studentSubmission, setStudentSubmission] = useState([]);

  const [submitLoader, setSubmitLoader] = useState(false);
  const [showEndScreen, setShowEndScreen] = useState(false);
  const [showStudentComment, setShowStudentComment] = useState(false);
  const [newOne, setNewOne] = useState(false);

  const [endLoader, setEndLoader] = useState(false);

  const worker = useRef(null);
  // const newTimerRef = useRef(null);


  const [timerValue, setTimerValue] = useState("00:00");
  const newTimerRef = useRef(null);
  const [alert, setAlert] = useState({
    open: false,
    message: "",
  });
  const [inputValuestudent, setInputValuestudent] = useState("");
  const { firestore, database, onValue, databaseRef, databaseSet , firebaseUser } = useFirebase();
  const [deleteModal, setDeleteModal] = useState(false);
  const { fetchClassGameActivity } = useClassGameActivity();
  const { profile_config } = useUserProfileConfig();

  const user_profile_img = get(profile_config, "config.profile_pic", "");

  const debate_configuration = get(debateResponse, 'configurations', '') || {};

  const upsertDebatePresence = async (debateData, status = "joined") => {
    try {
      const userId = get(currentUser, "id", "");
      if (!debateData?.id || !userId) return;
      const presenceId = `${debateData.id}_${userId}`;
      const presenceRef = doc(firestore, "debate_presence", presenceId);
      const payload = {
        debate_id: debateData.id,
        class_id: debateData.class_id,
        user_id: userId,
        user_name: `${get(currentUser, "firstName", "")} ${get(currentUser, "lastName", "")}`.trim(),
        status,
        joined_modal: true,
        updated_at: moment().toISOString(),
      };
      const snap = await getDoc(presenceRef);
      if (snap.exists()) {
        await updateDoc(presenceRef, payload);
      } else {
        await setDoc(presenceRef, {
          ...payload,
          created_at: moment().toISOString(),
        });
      }
    } catch (error) {
      console.log("Error updating debate presence:", error);
    }
  };

  const getJoinedStudentCount = async (debateId) => {
    try {
      if (!debateId) return 0;
      const presenceQuery = query(
        collection(firestore, "debate_presence"),
        where("debate_id", "==", debateId),
        where("status", "==", "joined")
      );
      const presenceSnap = await getDocs(presenceQuery);
      return presenceSnap.size || 0;
    } catch (error) {
      console.log("Error getting joined student count:", error);
      return 0;
    }
  };



  useEffect(() => {
    const fetchData = async () => {
      if(!firebaseUser) return;
      const twoDaysAgo = moment().subtract(2, 'days').toISOString();
      const collectionRef = collection(firestore, "debate");
      const q = query(collectionRef, where("status", "==", false), where("created_at", "<=", twoDaysAgo));
      try {
        // const querySnapshots = await getDocs(collectionRef);
        // const totaCount = querySnapshots.size;
        const querySnapshot = await getDocs(q);
        const count = querySnapshot.size;
        if (count > 0) {
          querySnapshot.forEach(doc => {
            deleteDoc(doc.ref).then(() => {
              return
            }).catch(error => {
              Sentry.captureException(`542 Error deleting document: ${error}`);
              console.error(`Error deleting document: ${error}`);
            });
          });
        }
      } catch (error) {
        Sentry.captureException(`543 Error getting documents: ${error}`);
        console.error(`Error getting documents: ${error}`);
      }
    };

    fetchData();
  }, [firebaseUser])

  const createNewCollection = async (value) => {
    // Create a new collection
    setSubmitLoader(true);
    const user_id = get(currentUser, 'id', '');
    const studentAnswer = {
      answer_time: moment().toISOString(),
      user_id: get(currentUser, "id", ''),
      user_name: `${get(currentUser, 'firstName', '')} ${get(currentUser, 'lastName', '')}`,
      answer_text: value,
      debate_id: debateResponse?.id,
      submission_id: v4(),
      response_id: '',
      comment: [],
      user_profile_img: user_profile_img,
      isSubmitted: true
    }
    const generated_session_id = user_id + debateResponse?.id;
    const docRef = doc(firestore, "debate_submission", generated_session_id);
    try {
      // Start the transaction
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(docRef, studentAnswer)
      } else {
        await setDoc(docRef, studentAnswer)
      }
      if (debateResponse?.debate_type === 'individual_question') {
        setShowEndScreen(true);
      } else {
        // setShowStudentComment(true);
        if (timer === 0) {
          setShowEndScreen(true)
        } else {
          setShowStudentComment(true);
        }
      }
      setSubmitLoader(false);
      setInputValuestudent('');
    } catch (e) {
      Sentry.captureException(`544 Error adding document: ${e}`);
      console.log('Error adding document: ', e);
    }
  };

    const updateStudentSubmission = async (studentAnswer, student_id) => {
    // Create a new collection
    const generated_session_id = student_id + debateResponse?.id;
    const docRef = doc(firestore, "debate_submission", generated_session_id);
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(docRef, studentAnswer)
      } else {
        await setDoc(docRef, studentAnswer)
      }
    } catch (e) {
      console.log('Error adding document: ', e);
    }
  };

  useEffect(() => {
    const unsubscribe = listenToNewDebates(
      currentClass?.id,
      handleChangeDebate,
      openTeacherModal
    );

    return () => {
      unsubscribe();
    };
  }, [firestore, currentClass?.id, previousDebateId, openTeacherModal]);

  const listenToNewDebates = (classId, onChange, openTeacherModal) => {
    if (!classId) {
      return () => { }; // Return an empty function to avoid errors
    }
    const collectionRef = collection(firestore, "debate");
    const q = query(collectionRef, where("class_id", "==", classId)); // Assuming currentClass is an object containing the ID
    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const sessions = [];
        querySnapshot.forEach((doc) => {
          sessions.push({ id: doc.id, ...doc.data() });
        });
        onChange(sessions, openTeacherModal);
      },
      (error) => {
        if (error.code === 'permission-denied') {
          console.warn("Permission denied for debate collection. User may not be properly authenticated.");
          return;
        }
        console.error('Error listening to new debates:', error);
      }
    );
    return unsubscribe; // Return the unsubscribe function
  };

  const handleChangeDebate = (sessions, openTeacherModal) => {


    const currentDate = new Date();
    const filteredData = sessions?.find((item) => {
      const createdAt = new Date(item.created_at);
      // Compare the dates (ignoring time)
      return (
        createdAt.toDateString() === currentDate.toDateString() &&
        item?.status === true
      );
    });
    if (filteredData) {

      if (filteredData.id !== previousDebateId) {
        setCloseStudentModal(false); // Set closeStudentModal to false when a new debate starts
        setPreviousDebateId(filteredData.id); // Update previousDebateId to the ID of the new debate
        // Reset student states when a new debate starts
        if (get(currentUser, "role") === "student") {
          setShowEndScreen(false);
          setShowStudentComment(false);
          setInputValuestudent("");
          // Reset timer state to ensure proper initialization
          setTimerValue("00:00");
          if (newTimerRef.current) {
            newTimerRef.current = null;
          }
        }
        listenToShareData(currentClass?.id);
        if (get(currentUser, "role") === "teacher" && !openTeacherModal) {
          // invokeDebateModal();
          setEditClick(false);
          if (filteredData.debate_type === "individual_question") {
            setAllContentType(true);
          }
          if (filteredData.debate_type === "live_debate") {
            setCommentContentType(true);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (debateResponse && currentUser) {
      const collectionRef = collection(firestore, "debate_submission");

      const q = query(
        collectionRef,
        where("debate_id", "==", get(debateResponse, "id", ""))
      );
      const timerRef = databaseRef(
        database,
        "debateTimer/" + debateResponse.id
      );
      onValue(timerRef, (snapshot) => {
        const timerData = snapshot.val();
        const timer = timerData?.time || 0;
        onSnapshot(q, (querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();

            if (
              openStudentModal === "" &&
              get(currentUser, "role") === "student"
            ) {
              // Only show end screen if student has actually submitted a non-empty answer
              if (
                data.answer_text.trim() !== "" &&
                data.user_id == currentUser.id
              ) {
                if (debateResponse?.debate_type === "individual_question") {
                  setShowEndScreen(true);
                } else {
                  if (debateResponse?.debate_type === "live_debate") {
                    if (timer === 0) {
                      invokeDebateModal();
                      setShowEndScreen(true);
                    } else {
                      setShowStudentComment(true);
                    }
                  }
                }
              } 
              // Remove the logic that was setting showEndScreen for empty submissions
              // This was causing the issue where end screen showed by default
            }
          });
        });
      });
    }
  }, [debateResponse, currentUser, openStudentModal]);
  // setCommentContentType(true)
  const onClose = () => {
    if(setDebatesModal){
      setDebatesModal(false);
      setInputValuestudent('');
    }
    if (get(currentUser, "role") === "student") {
      setCloseStudentModal(true);
    }
    if (
      Object.keys(debateResponse).length > 0 &&
      get(currentUser, "role") === "teacher"
    ) {
      setDeleteModal(true);
    } else {
      updateStatus();
    }
    setNewOne(false);
  };

  const endDebateUpdate = async (debateId) => {
    const sessionRef = doc(firestore, "debate", debateId);
    try {
      await runTransaction(firestore, async (transaction) => {
        const sessionDoc = await transaction.get(sessionRef);
        if (!sessionDoc.exists()) {
          return;
        }
        transaction.update(sessionRef, { status: false });
      });
    } catch (e) {
      Sentry.captureException(`545 Transaction failed: ${e}`);
      console.log("Transaction failed: ", e);
    }
  };

  const updateOneWayDebate = async () => {
    const collectionRef = collection(firestore, "debate_submission");
    const q = query(
      collectionRef,
      where("debate_id", "==", debateResponse?.id)
    );
    onSnapshot(
      q,
      (querySnapshot) => {
        const sessions = [];
        querySnapshot.forEach((doc) => {
          sessions.push({ id: doc.id, ...doc.data() });
        });
        const updateData = {
          ...debateResponse,
          status: false,
          answer: JSON.stringify(sessions),
        };
        dispatch(handleUpdateOneWayDebate(updateData));
        syncAssignment(updateData);
      },
      (error) => {
        console.error("Error listening to session changes:", error);
      }
    );
    await endDebateUpdate(debateResponse?.id);
  };
  async function syncAssignment(debutInfo) {
    const { grade: is_graded } = debutInfo.configurations;
    const answer = JSON.parse(get(debutInfo, "answer", "[]"));
    if (is_graded) {
      const studentJoinCount = await getJoinedStudentCount(debutInfo.id);
      await dispatch(
        handleSyncDebate({
          debut_id: debutInfo.id,
          student_join_count: studentJoinCount || answer.length,
          meta_data: {
            page_cover_url: debatePoster,
          },
          submissions: map(answer, (info) => ({
            answer: info.answer_text,
            comment: map(info.comment, (k) => ({
              reply_text: k.reply_text,
              user_id: k.user_id,
              user_name: k.user_name,
              user_profile_img: k.user_profile_img,
            })),
            user_id: info.user_id,
            user_name: info.user_name,
            user_profile_img: info.user_profile_img,
          })),
        })
      );
      Promise.allSettled([
        fetchClassGameActivity(),
        dispatch(handleListClassSubmissions(currentClass.id, false)),
      ]);
    } else {
      console.log("No need to sync grade assignment");
    }
  }
  const updateStatus = async () => {
    if (
      Object.keys(debateResponse).length > 0 &&
      get(currentUser, "role") === "teacher"
    ) {
      setEndLoader(true);
      await updateOneWayDebate();
      cleanupDebate('001');
      setEndLoader(false);
      setDeleteModal(false);
    }
    closeAllState();
  };

  const closeAllState = () => {
    setEditClick(true);
    setContentType(false);
    setAllEditClick(true);
    setAllContentType(false);
    setStudentEditClick(true);
    setStudentContentType(false);
    setStudentEditBlog(true);
    setBlogContentType(false);
    setStudentCommentSec(true);
    setCommentContentType(false);
    setInputValuestudent("");
    // cleanupDebate('0002');
    revokeDebateModal();
  };

  const handleClickHide = () => {
    setEditClick(false);
    setContentType(true);
  };

  const onCheckActiveDebate = async (debate) => {
    const currentTime = new Date();
    const createdAt = new Date(debate.created_at);
    const totalTimeParts = debate.configurations.total_time;
    const totalMilliseconds = parseInt(totalTimeParts) * 1000;
    const debateEndTime = new Date(createdAt.getTime() + totalMilliseconds);
    if (currentTime >= debateEndTime) {
      await updateStatus();
      revokeDebateModal();
      return;
    }
  };

  useEffect(() => {
    if (Object.keys(debateResponse).length > 0) {
      onCheckActiveDebate(debateResponse);
    }
  }, [debateResponse]);

  // Function to format time as mm:ss
  function formatTime(totalSeconds) {
    // const totalSeconds = Math.floor(milliseconds / 1000);
    // const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""
      }${seconds}`;
  }
  const listenToShareData = (classId) => {
    if (!classId) {
      return;
    }

    try {
      const collectionRef = collection(firestore, "debate");
      const q = query(collectionRef, where("class_id", "==", classId));
      const unsubscribe = onSnapshot(
        q,
        async (querySnapshot) => {
          const sessions = [];
          querySnapshot.forEach((doc) => {
            sessions.push({ id: doc.id, ...doc.data() });
          });
          const currentDate = new Date();
          const filteredData = sessions.find((item) => {
            const createdAt = new Date(item.created_at);
            // Compare the dates (ignoring time)
            return (
              createdAt.toDateString() === currentDate.toDateString() &&
              item?.status === true
            );
          });
          // if (filteredData?.status === "show_name") {
          //   setShowStudentNames(true);
          // } else if (filteredData?.status === "hide_name") {
          //   setShowStudentNames(false);
          // }
          if (filteredData) {
            const getPreviousTime = await getDebateTimer(filteredData);
            const timeComponents =
              getPreviousTime ? getPreviousTime : filteredData?.configurations?.total_time || 0;
            setDebateResponse(filteredData);
            if (get(currentUser, "role") === "teacher") {
              saveTimmerRealTime(filteredData, timeComponents, 'main listen');
            }
          } else {
            setDebateResponse({});
            closeAllState();
          }
          if (get(currentUser, "role") === "student") {
            if (filteredData) {
              setNewOne(false);
              await upsertDebatePresence(filteredData, "joined");
              invokeDebateModal();
            } else {
              // cleanupDebate();
              revokeDebateModal();
            }
          }
          setShowEndScreen(false);
          setShowStudentComment(false);
        },
        (error) => {
          if (error.code === 'permission-denied') {
            console.warn("Permission denied for Firestore collection. User may not be properly authenticated.");
            return;
          }
          console.log("Error listening to session changes:", error);
        }
      );

      return unsubscribe;
    } catch (error) {
      Sentry.captureException(`546 listen error!.${error}`);
      console.log("listen error", error);
    }
  };
  
  const getDebateTimer = (filteredData) => {
    if (filteredData) {
      return new Promise((resolve, reject) => {
        const timerRef = databaseRef(
          database,
          "debateTimer/" + filteredData.id
        );
        onValue(timerRef, (snapshot) => {
          const timerData = snapshot.val();
          const timer = timerData?.time || 0;
          if (timer > 0) {
            resolve(timer);
          } else {
            resolve(0);
          }
        })
      })
    }
  }

  const handleShare = async (
    debateType,
    configuration,
    question,
    grade,
    gradeConfig
  ) => {
    const key = v4();
    setShareLoader(true);
    const configurations = {
      grade,
      grade_config: grade ? gradeConfig : {},
      showStudent: false,
      ...configuration,
    };
    const submitData = {
      id: key,
      question,
      debate_type: debateType,
      user_id: get(currentUser, "id", ""),
      class_id: get(currentClass, "id", ""),
      status: true,
      configurations,
      answer: {},
    };
    const result = await dispatch(handleCreateOneWayDebate(submitData));
    if (result) {
      await addDataWithUUIDIfNotExist(key, result);
      if (debateType === "live_debate") {
        handleClickCommentDetail();
      } else {
        setAllEditClick(false);
        setAllContentType(true);
      }
    }
    setShareLoader(false);
  };

  // Function to add data with UUID if the document with the ID does not exist
  const addDataWithUUIDIfNotExist = async (id, data) => {
    const docRef = doc(firestore, "debate", id);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      try {
        await setDoc(docRef, data);
      } catch (e) {
        Sentry.captureException(`547 Error adding document: ${e}`);
        console.log("Error adding document: ", e);
      }
    }
  };
  useEffect(() => {
    let session_unsubscribe;
    if (!closeStudentModal && firebaseUser) {
      session_unsubscribe = listenToShareData(currentClass?.id);
    }
    return () => {
      if (session_unsubscribe && typeof session_unsubscribe === 'function') {
        session_unsubscribe();
      }
    };
  }, [firestore, firebaseUser]);

  useEffect(() => {
    let session_unsubscribe;
    // if (debateResponse && debateResponse?.id) {
    if (firebaseUser) {
      session_unsubscribe = listenToSubmissionData(
        debateResponse?.id,
        userSubmissionsHandler
      );
    }
    // }
    return () => {
      if (session_unsubscribe && typeof session_unsubscribe === 'function') {
        session_unsubscribe();
      }
    };
  }, [firestore, debateResponse, newOne, firebaseUser]);

  const listenToSubmissionData = (debateId, onChange) => {
    if (!debateId) {
      return () => { };
    }
    try {
      const collectionRef = collection(firestore, "debate_submission");
      const q = query(collectionRef, where("debate_id", "==", debateId));
      const unsubscribe = onSnapshot(
        q,
        (querySnapshot) => {
          const submission = [];
          querySnapshot.forEach((doc) => {
            submission.push({ id: doc.id, ...doc.data() });
          });
          onChange(submission);
        },
        (error) => {
          if (error.code === 'permission-denied') {
            console.warn("Permission denied for Firestore collection. User may not be properly authenticated.");
            return;
          }
          console.log("Error listening to session changes:", error);
        }
      );

      return unsubscribe;
    } catch (error) {
      Sentry.captureException(`548 listen error!.${error}`);
      console.log("listen error", error);
    }
  };

  const userSubmissionsHandler = (data) => {
    if (newOne) return;
    setStudentSubmission(data);
  };

  // useEffect(() => {
  //   try {
  //     if (get(currentUser, "role") !== "teacher") return;
  //     if (timer && Object.keys(debateResponse).length > 0) {
  //       const intervalFunction = () => {
  //         if (timer === 0) {
  //           clearInterval(countdownInterval);
  //           saveTimmerRealTime(debateResponse, 0, 'lisener 1');
  //           return;
  //         }
  //         if (timer > 0) {
  //           const newTime = timer - 1;
  //           if (newTime != timer) {
  //             saveTimmerRealTime(debateResponse, newTime, 'lisener 2');
  //           }
  //         }
  //       };
  //       const countdownInterval = setInterval(intervalFunction, 1000);
  //       return () => clearInterval(countdownInterval);
  //     }
  //   } catch (e) {
  //     console.log("error running time", e);
  //   }
  // }, [timer, debateResponse]);

  useEffect(() => {
    if (Object.keys(debateResponse).length > 0) {
      const timerRef = databaseRef(
        database,
        "debateTimer/" + debateResponse.id
      );
      const unsubscribe = onValue(timerRef, (snapshot) => {
        try {
          const timerData = snapshot.val();
          const dbTime = timerData?.time || 0;
          
          if (dbTime > 0) {
            // Timer is still running, sync with worker
            worker.current.postMessage({ 
              command: "start", 
              time: dbTime,
              role: get(currentUser, "role")
            });
            
            // Update local storage if needed
            const storedData = localStorage.getItem(`debate_timer_${debateResponse.id}`);
            if (storedData) {
              try {
                const { totalTime } = JSON.parse(storedData);
                if (dbTime > totalTime) {
                  saveTimerState(debateResponse.id, dbTime);
                }
              } catch (e) {
                // If stored data is corrupted, save fresh state
                saveTimerState(debateResponse.id, dbTime);
              }
            } else {
              saveTimerState(debateResponse.id, dbTime);
            }
          } else {
            // Timer has expired in database, stop local timer
            if (worker.current) {
              worker.current.postMessage({ command: "stop" });
            }
            setTimerValue("00:00");
            setTimer(0);
            newTimerRef.current = 0;
            localStorage.removeItem(`debate_timer_${debateResponse.id}`);
          }
        } catch (error) {
          Sentry.captureException(`549 error in database timer: ${error}`);
          console.log("error in database timer", error);
        }
      });
      return () => unsubscribe();
    }
  }, [database, debateResponse]);

  // New useEffect to call saveTimmerRealTime every 1 minute
  useEffect(() => {
    if ((Object.keys(debateResponse).length > 0 && currentUser?.role === 'teacher')) {
      const intervalId = setInterval(() => {
        saveTimmerRealTime(debateResponse, newTimerRef.current, 'interval sync');
      }, 60000); // 60000 ms = 1 minute

      return () => clearInterval(intervalId);
    }
  }, [debateResponse, currentUser, database]);

    // Function to get remaining time from storage
    const getRemainingTime = (debateId) => {
      try {
        const storedData = localStorage.getItem(`debate_timer_${debateId}`);
        if (storedData) {
          const { endTime, totalTime } = JSON.parse(storedData);
          const now = Date.now();
          const remaining = Math.max(0, Math.floor((endTime - now) / 1000));
          
          // If timer has expired, clean up storage
          if (remaining <= 0) {
            localStorage.removeItem(`debate_timer_${debateId}`);
            return 0;
          }
          
          // Ensure remaining time doesn't exceed original total time
          if (remaining > totalTime) {
            localStorage.removeItem(`debate_timer_${debateId}`);
            return null;
          }
          
          return remaining;
        }
      } catch (error) {
        Sentry.captureException(`550 error getting remaining time: ${error}`);
        console.error('Error getting remaining time:', error);
        // Clean up corrupted data
        localStorage.removeItem(`debate_timer_${debateId}`);
      }
      return null;
    };


      // Function to save timer state
  const saveTimerState = (debateId, totalSeconds) => {
    try {
      if (!debateId || totalSeconds < 0) {
        return;
      }
      
      const now = Date.now();
      const endTime = now + (totalSeconds * 1000);
      localStorage.setItem(`debate_timer_${debateId}`, JSON.stringify({
        endTime,
        totalTime: totalSeconds,
        debateId,
        createdAt: now
      }));
    } catch (error) {
      Sentry.captureException(`551 error saving timer state: ${error}`);
      console.error('Error saving timer state:', error);
    }
  };

  const formatTimeNew = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Initialize worker with persistent state
  useEffect(() => {
    worker.current = new Worker(`${(import.meta.env.BASE_URL || '/').replace(/\/?$/, '/')}timeWorker.js?t=8`);

    worker.current.onmessage = (event) => {
      switch (event.data.type) {
        case "tick":
          newTimerRef.current = event.data.countdownTime;
          const formattedTime = formatTimeNew(event.data.countdownTime);
          setTimerValue(formattedTime);
          setTimer(event.data.countdownTime);
          break;
        case "done":
          newTimerRef.current = 0;
          setTimerValue("00:00");
          setTimer(0);
          if (debateResponse?.id) {
            localStorage.removeItem(`debate_timer_${debateResponse.id}`);
          }
          break;
        case "reset":
          newTimerRef.current = 0;
          setTimerValue("00:00");
          setTimer(0);
          break;
      }
    };

    return () => {
      if (worker.current) {
        worker.current.postMessage({ command: "stop" });
        worker.current.terminate();
      }
    };
  }, []);

  // Handle tab visibility changes and window focus to sync timer
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && worker.current && debateResponse?.id) {
        // When tab becomes visible, sync the timer
        worker.current.postMessage({ command: 'sync' });
      }
    };

    const handleWindowFocus = () => {
      if (worker.current && debateResponse?.id) {
        // When window gains focus, sync the timer
        worker.current.postMessage({ command: 'sync' });
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleWindowFocus);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleWindowFocus);
    };
  }, [debateResponse?.id]);

  // Start or resume timer when debate response changes
  useEffect(() => {
    if (debateResponse?.id) {
      let initialTime;
      const remainingTime = getRemainingTime(debateResponse.id);
      
      if (remainingTime !== null && remainingTime > 0) {
        // Resume from stored state only if timer hasn't expired
        initialTime = remainingTime;
      } else if (debateResponse?.configurations?.total_time) {
        // Start fresh timer
        initialTime = parseInt(debateResponse.configurations.total_time);
        saveTimerState(debateResponse.id, initialTime);
      }

      if (initialTime !== undefined && initialTime > 0 && worker.current) {
        worker.current.postMessage({ 
          command: "start", 
          time: initialTime,
          role: get(currentUser, "role")
        });
      } else if (initialTime === 0 || initialTime === undefined) {
        // Timer has expired or no timer set, ensure it shows 00:00
        if (worker.current) {
          worker.current.postMessage({ command: "stop" });
        }
        setTimerValue("00:00");
        setTimer(0);
        newTimerRef.current = 0;
      }
    }
  }, [debateResponse]);

  // Cleanup function for when debate ends
  const cleanupDebate = (from) => {
    if (debateResponse?.id) {
      localStorage.removeItem(`debate_timer_${debateResponse.id}`);
      worker.current.postMessage({command: "stop"})
    }
  };

  const saveTimmerRealTime = async (debateData, time, from) => {
    // if (worker) {
    //   worker.postMessage({ command: "start", time: time });
    // }
    const dbRef = databaseRef(database, "debateTimer/" + debateData.id);
    databaseSet(dbRef, { time: time })
      .then((res) => { })
      .catch((error) => {
        Sentry.captureException(`552 Error updating time in the database: ${error}`);
        console.log("Error updating time in the database:", error);
      });
  };

    // Edit timer function for teacher
    // const editTimer = (editValue) => {
    //   try {
    //     const newEditTime = editValue + newTimerRef.current;
    //     if (newEditTime < 3600 && worker.current && debateResponse?.id) {
    //       worker.current.postMessage({ 
    //         command: "start", 
    //         time: newEditTime,
    //         role: get(currentUser, "role")
    //       });
    //       saveTimerState(debateResponse.id, newEditTime);
    //     }
    //   } catch (e) {
    //     console.log("Error updating timer: ", e);
    //   }
    // };

  const editTimer = async (editValue) => {
    try {
      const newEditTime = editValue + timer;
      if (newEditTime < 3600) {
        saveTimmerRealTime(debateResponse, newEditTime, 'edit');
        // const docRef = doc(firestore, "debate", debateResponse?.id);
        // // Start the transaction
        // const docSnap = await getDoc(docRef);
        // if (docSnap.exists()) {
        //   await updateDoc(docRef, { "configurations.total_time" : newEditTime });
        // }
        worker.current.postMessage({ 
          command: "start", 
          time: newEditTime,
          role: get(currentUser, "role")
        });
        saveTimerState(debateResponse.id, newEditTime);
      }
    } catch (e) {
      Sentry.captureException(`553 Error adding document: ${e}`);
      console.log("Error adding document: ", e);
    }
  };

  const handleClickStudentDetail = (i) => {
    setIndex(i);
    setStudentEditClick(false);
    setStudentContentType(true);
  };

  const handleClickLiveDebate = () => {
    setStudentEditBlog(false);
    setBlogContentType(true);
  };

  const handleClickCommentDetail = () => {
    setStudentCommentSec(false);
    setCommentContentType(true);
  };

  const handleCloseAlert = () => {
    setAlert({
      open: false,
      message: "",
    });
  };

  useEffect(() => {
    if (debateModal.view === true) {
      document.body.style.setProperty("overflow", "hidden", "important");
    } else {
      document.body.style.setProperty("overflow", "", "important");
    }
  }, [debateModal]);

  useEffect(() => {
    if (debatesModal) {
      if (
        get(currentUser, "role") === "student" &&
        Object.keys(debateResponse).length === 0
      ) {
        showAlert("No active debate", "error");
      } else {
        invokeDebateModal();
      }
    }
  }, [debatesModal]);

  const onChangeAvatar = async (avatar) => {
    if (!avatar || !debateResponse?.id) return;
    const user_profile_imgs = avatar;
  
    try {
      const q = query(
        collection(firestore, "debate_submission"),
        where("debate_id", "==", debateResponse?.id)
      );
  
      const querySnapshot = await getDocs(q);
  
      querySnapshot.forEach(async (docSnap) => {
        const docRef = docSnap.ref;
        const data = docSnap.data();
        const existingComments = data.comment || [];
  
        const updatedComments = existingComments.map((c) =>
          c.user_id === currentUser?.id
            ? { ...c, user_profile_img: user_profile_imgs }
            : c
        );
  
        const updates = { comment: updatedComments };
  
        if (data.user_id === currentUser?.id) {
          updates.user_profile_img = user_profile_imgs;
        }
  
        await updateDoc(docRef, updates);
      });
    } catch (error) {
      console.log("Error updating document: ", error);
      Sentry.captureException(`130 Error during Firebase onChangeAvatar ${error}.`);
    }
  };

  return (
    <SentryWrap>
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alert.open}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity="error">
          <strong>ALERT:</strong> {alert.message}
        </Alert>
      </Snackbar>
      <DebateModalWrapper
        role={get(currentUser, "role")}
        onClick={() => {
          if (
            get(currentUser, "role") === "student" &&
            Object.keys(debateResponse).length === 0
          ) {
            showAlert("No active debate", "error");
          } else {
            invokeDebateModal();
          }
        }}
        className="debateLogoBtnPart"
      >
        <img style={{ height: get(currentUser, "role") === "student" ? 40 : 30 }} src={get(currentUser, "role") === "student" ? debate_icon : newDebates} alt="Debate" />
      </DebateModalWrapper>
      <Modal
        classNames="NewGrpFtr"
        visible={debateModal.view}
        onCancel={onClose}
        destroyOnHidden={true}
        onClose={ () => { setInputValuestudent('');} }
        className="ideaOneModel debateOneModel"
        maskClosable={false}
      >
        {/* {Object.keys(debateResponse).length > 0 && !showEndScreen && <DebateTimer debateResponse={debateResponse} />} */}
        {/* {get(currentUser, "role") == "student" ? "" :  */}
        {get(currentUser, "role") === "student" && debateResponse ? (
          <StudentContent
            debateResponse={debateResponse}
            timer={newTimerRef.current !== null && newTimerRef.current !== undefined ? formatTime(newTimerRef.current) : null}
            submitLoader={submitLoader}
            showEndScreen={showEndScreen}
            showStudentComment={showStudentComment}
            studentSubmission={studentSubmission}
            onStudentAnswer={(value) => {
              createNewCollection(value);
            }}
            setInputValuestudent={setInputValuestudent}
            inputValuestudent={inputValuestudent}
            setShowEndScreen={setShowEndScreen}
            setShowStudentComment={setShowStudentComment}
            setOpenStudentModal={setOpenStudentModal}
            onClickOpen={(nessw) => {
              setNewOne(nessw === 'open' ? true : false);
            }}
          />
        ) : (
          <>
            {studentEditBlog && editClick && (
              <DebateContent
                handleClickHide={() => {
                  handleClickHide();
                }}
                handleClickLiveDebate={() => handleClickLiveDebate()}
              />
            )}
            {allEditClick && contentType && (
              <DebateContentType
                shareLoader={shareLoader}
                // aiLoader={aiLoader}
                // handleClickHideSec={(value, question, grade) => handleShare('individual_question', value, question, grade)}
                handleClickHideSec={debounce(
                  (value, question, grade, gradeConfig) => {
                    handleShare(
                      "individual_question",
                      value,
                      question,
                      grade,
                      gradeConfig
                    );
                  },
                  500
                )}
                onAiError={() => {
                  setAlert({
                    open: true,
                    message: "Please try with other question.",
                  });
                }}
                setOpenTeacherModal={setOpenTeacherModal}
              />
            )}

          </>
        )}

        {studentEditClick && allContentType && debateResponse && (
          <>
            <DebateStudentType
              handleClickStudentDetail={(i) => handleClickStudentDetail(i)}
              debateInfo={debateResponse}
              timer={timerValue}
              studentSubmission={studentSubmission}
              onEditTimer={(val) => {
                editTimer(val);
              }}
            />
          </>
        )}

        {studentContentType && (
          <DebateStudentDetail
            debateInfo={debateResponse}
            indexs={indexs}
            studentSubmission={studentSubmission}
            handleClickAnswerDetail={() => {
              setStudentEditClick(true);
              setStudentContentType(false);
            }}
          />
        )}
        {studentCommentSec && blogContentType && (
          <DebateLiveSection
            shareLoader={shareLoader}
            handleLiveShare={(value, question, grade, gradeConfig) => {
              handleShare("live_debate", value, question, grade, gradeConfig);
            }}
            onAiError={() => {
              setAlert({
                open: true,
                message: "Please try with other question.",
              });
            }}
            setOpenTeacherModal={setOpenTeacherModal}
          />
        )}

        {commentContentType && (
          <>
            <DebateCommentSection
              studentSubmission={studentSubmission}
              debateResponse={debateResponse}
              timer={timerValue}
              onEditTimer={(val) => {
                editTimer(val);
              }}
              updateStudentSubmission={updateStudentSubmission}
              isOpenEditMode={newOne}
              onClickOpen={(nessw) => {
                setNewOne(nessw === 'open' ? true : false);
              }}
            />
          </>
        )}
        <div className="widgetFooter NewIdeaFtr"><label>Pop Up</label></div>
      </Modal>
      <ProfileAvatarPicker onChangeAvatar={onChangeAvatar} />
      <DeleteModal
        message={`Are you sure you want to end this debate?`}
        deleteToggle={deleteModal}
        setDeleteToggle={setDeleteModal}
        loading={endLoader}
        onDelete={updateStatus}
        buttonTitle={"Yes"}
      />
    </div>
    </SentryWrap>
  );
};

const DebateContent = ({
  handleClickHide = () => null,
  handleClickLiveDebate = () => null,
}) => {
  const inpRef = useRef();
  return (
    <div className="ideaMdlUpr">
      <Row>
        <Col xs={24} xl={6}>
          <div className="debateMdlTop">
            <img src={DebateNewLogo} alt="Debate" />
            <DemoPreview video_id={"debate-demo"} wrapperStyle={{ width: "50%" }} />
          </div>
        </Col>
        <Col xs={24} md={12} xl={9}>
          <div className="debateTopSec">
            <div
              className="debateCircle debateYellow"
              onClick={() => {
                handleClickHide();
              }}
            >
              Individual <br /> question
            </div>
          </div>
        </Col>
        <Col xs={24} md={12} xl={9}>
          <div className="debateTopSec">
            <div
              className="debateCircle debeteBlue"
              onClick={() => {
                handleClickLiveDebate();
              }}
            >
              Live blog <br /> debate
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DebateModal;
